import {
  ControlField,
  IControlField,
  IControlField2,
  IFieldResponse
} from './control-field.base';

export interface ITextControlField extends IControlField {
  payload_dtype: string;
  value_dtype: string;
  default_value: string;
  response_dtype: string;
}

export interface ITextControlField2 extends IControlField2 {
  default_value?: string;
}
export default class TextControlField
  extends ControlField
  implements IControlField
{
  payload_dtype: string;

  value_dtype: string;

  default_value: string;

  response_dtype: string;

  constructor(field: ITextControlField) {
    super(field);
    this.payload_dtype = field.payload_dtype;
    this.value_dtype = field.value_dtype;
    this.response_dtype = field.response_dtype;
    this.default_value = field.default_value || '';
  }
}

export function toTextField(field: IFieldResponse): ITextControlField2 {
  return {
    id: field.id,
    alias: field.alias,
    control_type: field.control_type,
    default_value: field.default_value as string,
    helper_text: field.helper_text,
    is_visible: field.is_visible,
    is_active: field.is_active,
    is_disabled: field.is_disabled,
    is_mandatory: field.is_mandatory,
    is_hierarchical: field.is_hierarchical,
    name: field.name,
    placement_order: field.placement_order,
    section: field.section || '',
    dtype: field.dtype,
    is_auto_fill: field.is_auto_fill,
    planner_flag: field.planner_flag,
    info_details: field.info_details,
    is_info_enable: field.is_info_enable
  };
}
